import { pushEventInfo, setEvent } from './analytics';
export var setCancelEvent = function (settings) {
    setEvent('button submission', {
        eventName: 'my account settings',
    }, {
        myAccount: {
            settings: settings,
        },
    });
};
export var setVerificationCodeSendAndResendAnalytics = function (verificationMethod, isResend) {
    if (isResend === void 0) { isResend = false; }
    var event = {
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: "convert to pro: verify your identity: ".concat(isResend ? 'resend code' : 'verification code', ": ").concat(verificationMethod),
        },
    };
    pushEventInfo(event);
};
